import { useEffect, useState } from 'react';
import { BREAKPOINT_WIDTH__TABLET } from '../../configurations/constants';

const DESKTOP_MEDIA_QUERY = `(min-width: ${BREAKPOINT_WIDTH__TABLET}px)`;

const matchesDesktop = (): boolean =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia(DESKTOP_MEDIA_QUERY).matches;

/**
 * True at the same width the theme's `mediaQueries.medium` switches to the
 * desktop layout. Use it to avoid mounting (and fetching data for) parts of
 * the UI that are only shown on one layout.
 */
const useIsDesktop = (): boolean => {
  const [isDesktop, setIsDesktop] = useState(matchesDesktop);

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;

    const mediaQueryList = window.matchMedia(DESKTOP_MEDIA_QUERY);
    const handleChange = () => setIsDesktop(mediaQueryList.matches);

    handleChange();
    mediaQueryList.addEventListener('change', handleChange);
    return () => mediaQueryList.removeEventListener('change', handleChange);
  }, []);

  return isDesktop;
};

export default useIsDesktop;
